import { required } from "@vuelidate/validators";
const okurumgorusme = {
  data() {
    return {
      okurumgorusmeData: {
        Birimid: null,
        Tarih: null,
        Gorusulenkisi: null,
        Modulids: [],
        Gorusmesekli: null,
        Sonrakiadimtarihi: null,
        Aciklama: null,
        Dosyayolu: null,
      },
      FormDataType: {
        Birimid: { FieldName: "Birimid", Field: "combobox", FieldTitle: "Kurum", ComboData: {}, ComboDataArray: [], Multiple: false },
        Tarih: { FieldName: "Tarih", Field: "date", FieldTitle: "Görüşme Tarihi" },
        Gorusulenkisi: { FieldName: "Gorusulenkisi", Field: "input", FieldTitle: "Görüşülen Kişi" },
        Modulids: { FieldName: "Modulids", Field: "combobox", FieldTitle: "Görüşülen Modüller", ComboData: {}, ComboDataArray: [], Multiple: true },
        Gorusmesekli: { FieldName: "Gorusmesekli", Field: "combobox", FieldTitle: "Görüşme Şekli", ComboData: {}, ComboDataArray: [], Multiple: false },
        Sonrakiadimtarihi: { FieldName: "Sonrakiadimtarihi", Field: "date", FieldTitle: "Sonraki Adım Tarihi" },
        Aciklama: { FieldName: "Aciklama", Field: "textarea", FieldTitle: "Görüşme Notu" },
      }

    }
  },
  validations: {
    FormData: {
      Birimid: { required },
      Tarih: { required },
      Gorusulenkisi: {},
      Modulids: {},
      Gorusmesekli: {},
      Sonrakiadimtarihi: {},
      Aciklama: {},
      Dosyayolu: {},
    }
  },

  created() {

    this.ActionsFilterGet({ Service: "obirim/gettree", FullData: true, Filter: "" }).then((res) => {
      this.FormDataType.Birimid.ComboDataArray = res.Data
    });

    this.ActionsFilterGet({ Service: "okeyvalues", FullData: true, Filter: "&Asc=Kod&Tip=8" }).then((res) => {
      this.FormDataType.Modulids.ComboDataArray = res.Data.map(item => ({
        id: item.Id,
        label: item.Value
      }));
    });

    this.ActionsFilterGet({ Service: "okeyvalues", FullData: true, Filter: "&Asc=Kod&Tip=10" }).then((res) => {
      this.FormDataType.Gorusmesekli.ComboDataArray = res.Data.map(item => ({
        id: item.Id,
        label: item.Value
      }));
    });

  }
}
export default okurumgorusme
